import { get2 } from "@/shared/axios";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import useBranchId from "@/shared/hooks/useBranchId";
import { asArray, formatResponse } from "@/shared/utils/helpers";
import { OrderV2 } from "@/shared/v2/queries/interfacesV2";

const useUserOrdersInPosQuery = (userId: number) => {
  const branchId = useBranchId();

  const query = useQuery<OrderV2[]>({
    queryKey: ["userOrdersInPos", branchId, userId],
    queryFn: () =>
      get2(`/internal/secure/pos/v2/orders/users/orders/${branchId}/${userId}`),
    select: (data) => formatResponse(data),
    refetchOnWindowFocus: false,
  });

  const data = useMemo(() => {
    if (query.data) {
      return [...asArray(query.data)].reverse();
    }
  }, [query.data]);

  return { query, data };
};

export default useUserOrdersInPosQuery;
